import React, { useState } from "react";
import styled from "styled-components";
import CheckIcon from "../assets/images/icon-check.svg";
import { v4 as uuid_v4 } from "uuid";

const Container = styled.div`
  width: 45%;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(props) => props.theme["clr-card-bg"]};
  padding: 10px 20px;
  border-radius: 10px;

  @media (max-width: 600px) {
    width: 90%;
  }
`;

const Button = styled.button`
  width: 20px;
  height: 20px;
  border: 1.6px solid ${(props) => props.theme["clr-gb-5"]};
  background-color: transparent;
  border-radius: 50%;

  cursor: pointer;
  &.active {
    background-image: linear-gradient(
      45deg,
      hsl(192, 100%, 67%),
      hsl(280, 87%, 65%)
    );
  }
`;

const Icon = styled.img`
  width: 10px;
  height: 10px;
`;

const Input = styled.input.attrs({ type: "text" })`
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  height: 20px;
  padding: 20px 20px 20px 10px;
  font-size: 18px;
  color: ${(props) => props.theme["clr-gb-1"]};

  &::placeholder {
    color: hsl(234, 39%, 75%);
    font-weight: 300;
    font-size: 14px;
  }
`;

const InputBox = ({ setTodoList }) => {
  const [text, setText] = useState("");
  const [isCompleted, setIsCompleted] = useState(false);

  const handleChange = (e) => {
    if (e.key === "Enter") {
      setTodoList((prev) => [
        ...prev,
        { id: uuid_v4(), text: e.target.value, isCompleted: isCompleted },
      ]);
      setText("");
      setIsCompleted(false);
    }
  };

  return (
    <Container>
      <Button
        onClick={() => setIsCompleted((prev) => !prev)}
        className={isCompleted && "active"}
      >
        {isCompleted && <Icon src={CheckIcon} alt="" />}
      </Button>
      <Input
        value={text}
        placeholder="Create a new todo..."
        onChange={(e) => setText(e.target.value)}
        onKeyPress={handleChange}
        autoComplete="off"
        spellCheck={"false"}
      />
    </Container>
  );
};

export default InputBox;
